import React from 'react';
import { Route } from 'react-router-dom';
import AdminList from '../../ListPages/AdminList.js';
import UserList from '../../ListPages/RobotUsers/RobotUsersList1.js';
import RobotList from '../../ListPages/RobotUsers/RobotUsersList2.js';
import UsersList from '../../ListPages/UserList/UsersList1.js';
import UserDetailsList from '../../ListPages/UserList/UsersList2.js';
import UpdateUser from '../../ListPages/UserList/UsersList2.js';
import RobotMsgList1 from '../../ListPages/RobotMsg/RobotMsgList1.js';
import RobotMsgList2 from '../../ListPages/RobotMsg/RobotMsgList2.js';
import RobotMsgList3 from '../../ListPages/RobotMsg/RobotMsgList3.js';
import BookSession from '../../BookingRobot/BookSession.js';
import Sessiondetails from '../../BookingRobot/Sessiondetails.js';
import RobotForm from '../../DetailsUplode/CreateRobotForUser.js';
import RobotVersionList1 from '../../ListPages/RobotVersion/RobotVersionList1.js';
import RobotVersionList2 from '../../ListPages/RobotVersion/RobotVersionList2.js';
import { guardRoute } from '../ProtectedRoute';

export const usersRobotsRoutes = [
  <Route key="users-list" path="/users-list" element={guardRoute(<UsersList />, '/users-list')} />,
  <Route
    key="user-details"
    path="/user-details/:email"
    element={guardRoute(<UserDetailsList />, '/user-details/')}
  />,
  <Route key="update-user" path="/update-user" element={guardRoute(<UpdateUser />, '/update-user')} />,
  <Route key="admin-user" path="/admin-user" element={guardRoute(<AdminList />, '/admin-user')} />,
  <Route key="robot-form" path="/robot-form" element={guardRoute(<RobotForm />, '/robot-form')} />,
  <Route key="user-robot" path="/user-robot" element={guardRoute(<UserList />, '/user-robot')} />,
  <Route
    key="robots-email"
    path="/robots/:email"
    element={guardRoute(<RobotList />, '/robots/')}
  />,
  <Route
    key="robot-msg-list"
    path="/RobotMsgList"
    element={guardRoute(<RobotMsgList1 />, '/RobotMsgList')}
  />,
  <Route
    key="robot-msg-robot"
    path="/robot/:robotId"
    element={guardRoute(<RobotMsgList2 />, '/robot/')}
  />,
  <Route
    key="camera-images"
    path="/camera-images/:messageId"
    element={guardRoute(<RobotMsgList3 />, '/camera-images/')}
  />,
  <Route
    key="robot-booking"
    path="/Robot-Booking"
    element={guardRoute(<BookSession />, '/Robot-Booking')}
  />,
  <Route
    key="booking-details"
    path="/Booking-details"
    element={guardRoute(<Sessiondetails />, '/Booking-details')}
  />,
  <Route
    key="update-apppermission"
    path="/update-apppermession"
    element={guardRoute(<RobotVersionList1 />, '/update-apppermession')}
  />,
  <Route
    key="appdetails"
    path="/appdetails/:emailId"
    element={guardRoute(<RobotVersionList2 />, '/appdetails/')}
  />,
];
